<template>
  <div>
    <ProductHeader header="รายละเอียดข้อมูลสินค้า" :img_header="header_image" :link_back="$store.state.link_url"/>
    <Product_details/>
  </div>
</template>

<script>
import ProductHeader from "@/components/admin/manage_products/header_products/ProductHeader";
import Product_details from "@/components/admin/manage_products/Product_details";
import HeaderImage from "@/assets/stock.png";
export default {
  name: "ProductDetails",
  components: {
    Product_details,
    ProductHeader
  },
  data() {
    return {
      header_image:HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
